import { render, staticRenderFns } from "./Moneda.vue?vue&type=template&id=6a42df30"
import script from "./Moneda.vue?vue&type=script&lang=ts"
export * from "./Moneda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports